/** Statuses of the orders, per platform. */

export const ORDER_TYPES: Record<number, string> = {
  1: 'PENDING',
  2: 'CONFIRMED',
  3: 'IN PROGRESS',
  4: 'COMPLETED',
  5: 'RECEIVED',
  6: 'DELIVERED',
  7: 'CANCELLED',
  8: 'READY FOR PRODUCTION',
  9: 'REQUEST_SENT',
  10: 'PDF_SENT',
};

export const ABC_ORDER_TYPES: Record<number, string> = {
  1: 'PENDING',
  2: 'CONFIRMED',
  3: 'IN PROGRESS',
  4: 'COMPLETED',
  5: 'RECEIVED',
  6: 'DELIVERED',
  7: 'CANCELLED',
  8: 'READY FOR PRODUCTION',
};

export const DMS_ORDER_TYPES: Record<number, string> = {
  1: 'PENDING',
  7: 'CANCELLED',
  9: 'REQUEST_SENT',
  10: 'PDF_SENT',
};

export const CS = {
  PENDING: 1,
  CONFIRMED: 2,
  IN_PROGRESS: 3,
  COMPLETED: 4,
  RECEIVED: 5,
  DELIVERED: 6,
  CANCELLED: 7,
  READY_FOR_PRODUCTION: 8,
  REQUEST_SENT: 9,
  PDF_SENT: 10,
} as const;

export type StatusId = (typeof CS)[keyof typeof CS];

/** Status order: "ready for production" sits between confirmed and in progress. */
export const compareStatus = (
  type1: number | string,
  type2: number | string,
): number => {
  let a = Number(type1);
  let b = Number(type2);
  if (a === 8) a = 2.5;
  if (b === 8) b = 2.5;
  return a - b;
};

/** Status colours of the orders screen. */
export const STATUS_COLORS: Record<number, string> = {
  1: '#d30000',
  2: '#1b57f0',
  8: 'lightseagreen',
  3: '#d9a11b',
  4: '#00d3d1',
  5: 'palevioletred',
  6: '#4fcb42',
  7: 'gray',
};

/** Label of a status, empty for a part that has none yet. */
export const statusLabel = (status: number | null | undefined): string =>
  status == null ? '' : (ORDER_TYPES[status] ?? '');

/** Colour of a status, none for a part that has none yet. */
export const statusColor = (
  status: number | null | undefined,
): string | undefined => (status == null ? undefined : STATUS_COLORS[status]);
